

import React from "react"
import ReactDOM, { createRoot } from 'react-dom/client';

// import Footer from "./Footer.js"

import './index.css';

import RenderTest from "./App.js" 

import ProjOpengl from "./proj_opengl.js"
import ProjSpaceApps from "./projSpaceApps.js"
import ProjRoboArm from "./projRoboArm.js"
import ProjObjDetLib from "./projObjDetLib.js"
import ProjFourierDraw from "./projFourierDraw.js"
import ProjMastersThesis from "./projMastersThesis.js"

import { BrowserRouter, Routes, Route } from "react-router-dom";



const root = ReactDOM.createRoot(document.getElementById("root"))

root.render( <BrowserRouter>
            <Routes>
        <Route path="/" element={<RenderTest />} />    
        <Route path="/projMastersThesis" element={<ProjMastersThesis />} />
        <Route path="/proj_opengl" element={<ProjOpengl />} />
        <Route path="/projSpaceApps" element={<ProjSpaceApps />} />
        <Route path="/projRoboArm" element={<ProjRoboArm />} />
        <Route path="/projObjDet" element={<ProjObjDetLib />} />
        <Route path="/projFourierDraw" element={<ProjFourierDraw />} />

    </Routes>
    </BrowserRouter> 
 );
{/* <RenderTest/> */}


